import * as React from "react";
const SvgFile = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20 20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V9.24C4.0007 8.44462 4.31723 7.68207 4.88 7.12L9.12 2.88C9.68207 2.31723 10.4446 2.0007 11.24 2H18C19.1046 2 20 2.89543 20 4V20ZM6 10V20H18V4H12V9C12 9.55228 11.5523 10 11 10H6Z", fill: "currentColor" }));
export default SvgFile;
